import curry from 'lodash/curry.js';
import every from 'lodash/every.js';
import has from 'lodash/has.js';
import partial from 'lodash/partial.js';
export const hasEveryKey = curry((keys, obj) => {
    return every(keys, partial(has, obj));
});
